import { Component, EventEmitter, Output } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { BillingService, BillingInfoForUi } from 'src/app/services/billing.service';

@Component({
  selector: 'me-billing-banner',
  templateUrl: './billing-banner.component.html',
  styleUrls: ['./billing-banner.component.scss']
})
export class BillingBannerComponent {

  @Output() bannerVisibilityChange = new EventEmitter<boolean>();

  bannerInfo$: Observable<BillingInfoForUi | null> = combineLatest([
    this.$auth.isLoggedIn$,
    this.$auth.organization$
  ]).pipe(
    map(([isLoggedIn, org]) => {
      if (!isLoggedIn || !org) {
        return null;
      }

      return this.$billing.getBillingDisplayInfo(org, { displayContext: 'banner' });
    }),
    tap(bannerInfo => {
      this.bannerVisibilityChange.emit(bannerInfo !== null);
    })
  );

  constructor(
    private $auth: AuthService,
    private $billing: BillingService
  ) {}

  manageBilling() {
    this.$billing.manageBilling();
  }

}
